import { render, staticRenderFns } from "./DistTotalsByVat.vue?vue&type=template&id=18a0fcfc&scoped=true"
import script from "./DistTotalsByVat.vue?vue&type=script&lang=js"
export * from "./DistTotalsByVat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0fcfc",
  null
  
)

export default component.exports